import { Plus } from "lucide-react";

/**
 * Same-shipping upsell nudge: "Add another 50g for $15.99 — DHL rate doesn't change."
 * Shown when user hasn't hit max variant. Clicking adds another small variant.
 *
 * Props:
 *   onAdd: (variant) => void
 *   smallestVariant: {sku, weight, price}
 *   show: boolean
 */
export default function UpsellSameShipping({ onAdd, smallestVariant, show = true }) {
  if (!show || !smallestVariant) return null;
  return (
    <button
      type="button"
      onClick={() => onAdd(smallestVariant)}
      className="w-full text-left group"
      data-testid="upsell-same-shipping"
    >
      <div className="border border-[#C8A97E]/30 hover:border-[#C8A97E] p-4 bg-[#0A0E0A] transition-colors">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 border border-[#C8A97E]/40 flex items-center justify-center shrink-0 group-hover:bg-[#C8A97E]/10">
            <Plus size={16} className="text-[#C8A97E]" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-medium">
              Add another <span className="text-[#C8A97E]">{smallestVariant.weight}</span> — ${smallestVariant.price.toFixed(2)}
            </div>
            <div className="text-[11px] text-[#75726D] mt-0.5">
              Same DHL rate applies · ships in the same pouch run
            </div>
          </div>
        </div>
      </div>
    </button>
  );
}
